import { fmtTimeOfDay } from '../../lib/time.ts';

/** Source + "as of HH:MM:SS" attached to a value. No number renders without one
 *  of these nearby. `manual` entry is badged as such. */
export function Provenance({
  source,
  fetchedAt,
  isStale,
  entry,
  seeded,
}: {
  source: string;
  fetchedAt: string | null;
  isStale?: boolean;
  entry?: 'api' | 'manual';
  seeded?: boolean;
}) {
  return (
    <p className="provenance">
      <span className="provenance__source">{source}</span>
      {entry === 'manual' ? <span className="badge badge--manual">manual entry</span> : null}
      {seeded ? <span className="badge badge--seed">seed values</span> : null}
      <span className="provenance__time">
        as of <span data-numeric>{fmtTimeOfDay(fetchedAt)}</span>
      </span>
      {isStale ? <span className="badge badge--stale">stale</span> : null}
    </p>
  );
}
